


































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { Debounce } from 'lodash-decorators';
import { Family, Settings as SettingsInterface } from '@/interfaces/Models';

@Component
export default class Settings extends Vue {

    public families: Family[] = [];
    public familyName: any = null;
    public familyLoading: boolean = false;
    
    public settings: SettingsInterface = {

        catchup_family: null,

        created_at: '/',
        updated_at: '/'
    };

    public settingsErrors: any = {
        catchup_family_id: [],
    };

    public settingsLoading: boolean = false;

    public async update() {

        this.settingsLoading = true;

        const payload = this.getPayload();

        axios.post(api.path('v1.admin.settings'), payload)
            .then( res => {
                this.$toast.success(res.data.message);
            })
            .catch(err => {
                this.setErrors(err.response.data.errors);
            })
            .finally(() => this.settingsLoading = false);
    }

    public getPayload() {
        return {
            catchup_family_id: this.settings.catchup_family?.id || null,
        }
    }

    public setPayload(data: any) {
        // TODO: refactor this, ugly
        if ( data?.catchup_family != null ) this.families.push(data.catchup_family);
        
        this.settings = { ...data };
    
    }

    public setErrors(data: any) {
        this.settingsErrors = {...data}
        
    }

    public async loadSettings() {
        this.settingsLoading = true;

         axios.get(api.path('v1.admin.settings'))
            .then( res => this.setPayload(res.data.data))
            .finally(() => this.settingsLoading = false);
    }

    @Watch('familyName')
    @Debounce(500)
    onFamilyNameChange( value: string ): void {
        let params = {
            paginate: 'no',
            family: value
        }

        this.familyLoading = true;

        if ( value === null ) {
            this.familyLoading = false;
            this.families = [];
            return;
        }
        
        axios.get(api.path('v1.admin.families'), { params: params })
            .then( res => {
                this.familyLoading = false;
                this.families = res.data.data;
            });
    }
    

    public async mounted() {
        await this.loadSettings();
    }
}
